import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_ecomsync_branch_label_hdr_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  fi_branch_guid: fromDatatype.GuidDataFieldInterface;
  label_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
  label_hdr_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  acl_config: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_ecomsync_branch_label_hdr_link_RowClass
  implements bl_fi_ecomsync_branch_label_hdr_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    fi_branch_guid: fromDatatype.GuidDataFieldInterface;
    label_list_hdr_guid: fromDatatype.GuidDataFieldInterface;
    label_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    acl_config: fromDatatype.GuidDataFieldInterface;
    acl_policy: fromDatatype.GuidDataFieldInterface;
}
